import { styled } from "@mui/system";

export const EditDialogHeadline = styled("h1")(() => ({
  fontWeight: 700,
  fontSize: "16px",
}));
